<main class="error-page">
  <h1>404</h1>
  <h2>Not Found</h2>
</main>
